import Swal from "sweetalert2";
export const handleRentalUpdateSubmit = async (
  updatedData,
  {
    selectedRental,
    setIsUpdatingRental,
    setIsEditRentalModalOpen,
    setSelectedRental,
    fetchData,
    MySwal,
    rentals,
    cars,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  if (!selectedRental) return; // Should not happen, but safety first

  setIsUpdatingRental(true); // Start loading indicator
  try {
    // Assuming your rentals service has an 'update' method like: rentals.update(id, data)
    await rentals.update(selectedRental._id, updatedData);    setIsEditRentalModalOpen(false); // Close the modal
    setSelectedRental(null); // Clear the selected rental state
    fetchData(); // Refresh the rentals list to show changes

    // Show success message using Swal
    MySwal.fire({
      // Use the MySwal instance you already created
      title: "Rental Updated",
      text: "The rental has been successfully updated.",
      icon: "success",
      confirmButtonColor: "#1e3a8a", // Match your existing style
    });
  } catch (error) {
    console.error("Error updating rental:", error);
    MySwal.fire({
      title: "Update Failed",
      text: "Failed to update the rental. Please check the details and try again.",
      icon: "error",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setIsUpdatingRental(false); // Stop loading indicator
  }
};
